export default __webpack_public_path__ + "static/media/SSLLogo.e2999ded.svg";